module.exports = __webpack_public_path__ + "static/store-pixies-9b2e0ad317bcaab9fd1c488a7e0ab2be.svg";